import { getUserEmail } from "../../../utils/local-storage-user-info"

export const getInitialValues = () => ({
  email: getUserEmail(),
  firstName: "",
  lastName: "",
})
export type FormValues = ReturnType<typeof getInitialValues>
